import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {DefaultTitleStrategy, RouterStateSnapshot, TitleStrategy} from '@angular/router';

import {LocalizeService} from '@services/helpers/localize/localize.service';

@Injectable()
export class FitMedTitleStrategy extends DefaultTitleStrategy implements TitleStrategy {
  constructor(
    private readonly browserTitle: Title,
    private readonly localize: LocalizeService,
  ) {
    super(browserTitle);
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot)?.trim();
    const dynamicTitle = title ? this.localize.l(title, title).trim() : '';

    this.browserTitle.setTitle(dynamicTitle ? `FitMed | ${dynamicTitle}` : 'FitMed');
  }
}
